import React, { useEffect, useState } from 'react';

import { useBillingStore } from '../../store/models';
import ProgressDialog from './secureDialog';

import {
    setSharedAuth,
    getSharedAuth,
    logInfo,
} from '../../utils';


function isPilot () {
    return window.location.origin === 'https://test-pilot-app.ecal.com';
}
 
function get3dSecureRedirectURL () {
    const paths = {
        local: 'http://localhost:3000/',
        prod: 'https://app.ecal.com/',
        stage: 'https://stage-app.ecal.com/',
        pilot: 'https://test-pilot-app.ecal.com/',
        dev: 'https://test-app.ecal.com/',
    };

    let base = paths[window.env] ? paths[window.env] : paths.prop;
    if (isPilot()) {
        base = paths.pilot;
    }
    const redirectURL = `${base}3d.secure.redirect.html`;
    logInfo('get3dSecureRedirectURL()', redirectURL);
    return redirectURL;
}

function get3dSecureCallbackURL () {
    // securedCallback doens't need a pilot because it is a service.
    const paths = {
        local: 'http://localhost:3034/v4/billing/secure3DSCallback',
        prod: 'https://svc.ecal.com/v4/billing/secure3DSCallback',
        stage: 'https://stage-svc.ecal.com/v4/billing/secure3DSCallback',
        dev: 'https://test-svc.ecal.com/v4/billing/secure3DSCallback',
        // dev: 'http://localhost:3034/v4/billing/secure3DSCallback',
    };

    const url = paths[window.env] ? paths[window.env] : paths.dev.prod;
    logInfo('get3dSecureCallbackURL()', url);
    return url;
}

// 3D Secure Card Ex: 4000000000003220

function use3DSecure (props) {
    const {
        onAuthSuccess = () => {},
        onAuthFailed = () => {},
    } = props;

    const billingStore = useBillingStore();
    const [openAuth, setOpenAuth] = useState(false);

    const [actionURL, setActionURL] = useState('');

    useEffect(() => {
        // validates when local storage for key:ecal-v4-shared-auth has been updated.
        const handleStorageChange = (e) => {
            if (e.key === 'ecal-v4-shared-auth' && e.newValue) {
                billingStore.threeDSecureFinalized = false;
                logInfo('Storage Event: 3DS data detected instantly!');
                finalizeAuthentication();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    useEffect(() => {
        logInfo('CharigyAction Link is updated....');
        if (billingStore.chargifyActionLink) {
            handle3dSecure();
        }
    }, [billingStore.observed.chargifyActionLink]);

    function handle3dSecure () {
        setOpenAuth(true);
        openActionLink();
        startAuthentication();
        verifySharedAuth();
    }

    function verifySharedAuth () {
        const sharedAuth = getSharedAuth();
        if (sharedAuth.authenticated) {
            finalizeAuthentication();
        } else {
            setTimeout(() => verifySharedAuth(), 1000);
        }
    }

    function startAuthentication () {
        setSharedAuth({
            authenticated: false,
        });
    }

    function finalizeAuthentication () {
        const sharedAuth = getSharedAuth();
        setOpenAuth(false);
        if (sharedAuth.isSuccess) {
            if (!billingStore.threeDSecureFinalized) {
                billingStore.threeDSecureFinalized = true;
                onAuthSuccess();
            }
        } else {
            onAuthFailed(sharedAuth.message);
        }
    }

    function openActionLink () {
        billingStore.threeDSecureFinalized = false;
        const link = `${billingStore.chargifyActionLink}&redirect_url=${get3dSecureRedirectURL()}&callback_url=${get3dSecureCallbackURL()}`;
        logInfo('openActionLink() -> ', link);
        // window.open(link, '_blank');
        setActionURL(link);
    }

    function renderAuthDialog () {
        return (<ProgressDialog
            open={openAuth}
            url={actionURL}
        />);
    }

    return {
        renderAuthDialog,
    };
}

export default use3DSecure;
